import type { AppProps } from 'next/app';
import { I18nProvider } from 'next-localization';
import { SitecorePageProps } from 'lib/page-props';
import Bootstrap from 'src/Bootstrap';

// The below imports will be removed after SXA has been completed
// import 'assets/main.scss';
// import 'assets/styles/base.css';

import 'assets/styles/output.css';
import 'assets/styles/sxa/main.scss';
import 'assets/styles/themes/main.scss';
import 'assets/SingleLinePromo.variables.css';
import { NavContextProvider } from 'lib/react-context/NavContext';

function App({ Component, pageProps }: AppProps<SitecorePageProps>): JSX.Element {
  const { dictionary, ...rest } = pageProps;

  return (
    <>
      <Bootstrap {...pageProps} />
      {/*
        // Use the next-localization (w/ rosetta) library to provide our translation dictionary to the app.
        // Note Next.js does not (currently) provide anything for translation, only i18n routing.
        // If your app is not multilingual, next-localization and references to it can be removed.
      */}
      <I18nProvider lngDict={dictionary} locale={pageProps.locale}>
        <NavContextProvider>
          <Component {...rest} />
        </NavContextProvider>
      </I18nProvider>
    </>
  );
}

export default App;
